__turbopack_context__.v({
  "caption": "_0jgpvG_caption",
  "content": "_0jgpvG_content",
  "countdown": "_0jgpvG_countdown",
  "countdownWrapper": "_0jgpvG_countdownWrapper",
  "dropDateCopy": "_0jgpvG_dropDateCopy",
  "headingWithIcon": "_0jgpvG_headingWithIcon",
  "headingWrapper": "_0jgpvG_headingWrapper",
  "remindMeButton": "_0jgpvG_remindMeButton",
  "remindMeButtonWrapper": "_0jgpvG_remindMeButtonWrapper",
  "reminderSetLabel": "_0jgpvG_reminderSetLabel",
  "signupButton": "_0jgpvG_signupButton",
  "signupButtonWrapper": "_0jgpvG_signupButtonWrapper",
  "wrapper": "_0jgpvG_wrapper",
});
